import angular from 'angular';

import APIServices from './api/api.module';
import BrowserFunctions from './browser-functions/browser.module';
import Config from './config/config.module';
import Connections from './connections/connections.module';
import Converter from './converter/converter.module';
import Interface from './interface/interface.component';
import Misc from './misc/misc.module';
import ServiceWorker from './browser-functions/service-worker.service';
import Storage from './storage/storage.module';
import Tables from './tables/tables.module';
import Users from './users/users.module';

const DEPENDENCIES = [
  APIServices,
  BrowserFunctions,
  Config,
  Connections,
  Converter,
  Interface,
  Misc,
  ServiceWorker,
  Storage,
  Tables,
  Users,
];

/* @ngInject */
export default angular.module('autoboard.sharedServices', DEPENDENCIES)
  .name;
